import { IGif } from "services/types";

export enum ScrollSectionEnum {
  MANAGE_LINKS="MANAGE_LINKS",
}

export interface IEditGifPopupProps {
  gif: IGif;
  scrollToSection?: ScrollSectionEnum;
}
